import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-events-list-toolbar',
  templateUrl: './list-toolbar.event.component.html',
  styleUrls: ['./list-toolbar.event.component.scss'],
})
export class EventsListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
